import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileAlt,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Form,
  Row,
  Table,
  Pagination,
} from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetAllHost, StatusHost } from "../../../features/admin/host/slice";
import { IDS } from "../../../utils/IDS";
import { AllRoles } from "../../../features/admin/common/Slice";

const Student_Detail = () => {
  const dispatch = useDispatch();

  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [room, setRoom] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const navigate = useNavigate();

  const roomOptions = [
    { value: "all", label: "--All Room --" },
    { value: "room-101", label: "Room 101" },
    { value: "room-102", label: "Room 102" },
    { value: "room-103", label: "Room 103" },
    { value: "room-104", label: "Room 104" },
  ];

  const allRolesData = useSelector((state) => state.common.all_roles);
  useEffect(() => {
    dispatch(AllRoles());
  }, [dispatch]);

  const handleReset = () => {
    setRoom(null);
    setStudentName("");
    setFromDate("");
    setToDate("");
    setEmail("");
    setName("");
  };

  const Host = useSelector((state) => state.host.host);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const fetch = async (page = Host?.current_page) => {
    await dispatch(
      GetAllHost({
        name: name,
        email: email,
        room_id: room?.value,
        page: page,
        per_page: Host?.per_page,
      }),
    );
  };

  useEffect(() => {
    fetch();
  }, [name, email, room]);

  const handleStatusChange = async (id) => {
    try {
      await dispatch(StatusHost(id)).unwrap();

      setSuccess(true);

      // Refresh the host list
      dispatch(GetAllHost());
    } catch (error) {
      console.error("Status update failed:", error);
      setErr(true);
    }
  };

  const renderPagination = (data, handlePageChange) => {
    if (!data) return null;

    const currentPage = Number(data.current_page || 1);
    const perPage = Number(data.per_page || 10);
    const total = Number(data.total || 0);

    const lastPage = Math.ceil(total / perPage);

    if (lastPage <= 1) {
      return null;
    }

    return (
      <div className="d-flex justify-content-end mt-3">
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />

          {Array.from({ length: lastPage }, (_, index) => {
            const page = index + 1;

            return (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

          <Pagination.Next
            disabled={currentPage === lastPage}
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  const handleCustomerPageChange = (page) => {
    if (page < 1) return;

    fetch(page);
  };

  return (
    <section className="Recording_List common_section">
      <div className="common_btn_div">
        <button
          type="button"
          className="orange_btn"
          onClick={() => navigate("/host/detail/create")}
        >
          Create New Host
        </button>
      </div>
      <div className="section_filter_div">
        <div className="row">
          <div className="col-xl-2 col-md-3  col-sm-6">
            <Form.Control
              type="text"
              placeholder="Search by User Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="student_input"
            />
          </div>

          <div className="col-xl-2 col-md-3  col-sm-6">
            <Form.Control
              type="text"
              placeholder="Search by email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="student_input"
            />
          </div>

          <div className="col-xl-2 col-md-3  col-sm-6">
            <Select
              options={allRolesData}
              value={room}
              onChange={setRoom}
              placeholder="--All Role --"
              className="common_select"
              classNamePrefix="room"
              isSearchable={false}
            />
          </div>

          {/* SEARCH */}
          <div className="col-xl-2 col-md-3  col-sm-6  col-6 my-auto">
            {/* <button type="button" className="search_btn">
              Search
            </button> */}
          </div>
          <div className="col-xl-2 col-md-3  col-sm-6  col-6 my-auto">
            <button type="button" className="reset_btn" onClick={handleReset}>
              Reset
            </button>
          </div>
        </div>
      </div>

      <div className="sectin_top">
        <h2 className="section_name">Host List:</h2>
      </div>

      <div className="table-responsive custom-table-wrapper">
        <Table borderless className="custom-table text-center align-middle m-0">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Contact No</th>
              <th>Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {Host?.data?.length > 0 ? (
              Host?.data.map((val, index) => (
                <tr key={index}>
                  <td>
                    {(Host?.current_page - 1) * Host?.per_page + index + 1}
                  </td>
                  <td>{val?.user_name}</td>
                  <td>{val.email}</td>
                  <td>{val.contact_no || "-"}</td>
                  <td>{val.Role?.name}</td>
                  <td>
                    {/* <Form.Check
                      type="switch"
                      id={`custom-switch-${val?.id}`}
                      checked={val?.status}
                      onChange={() => {
                        handleStatusChange(val?.id);
                      }}
                      label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                    /> */}

                    <div className="green_switch_div">
                      <label className="custom_toggle">
                        <input
                          type="checkbox"
                          checked={Boolean(val?.status)}
                          onChange={() => handleStatusChange(val?.id)}
                        />

                        <span className="toggle_slider"></span>
                      </label>
                    </div>
                  </td>

                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Button variant="link" className="p-0 action-btn">
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          className="icon-edit"
                          onClick={() =>
                            navigate(`/host/detail/edit/${val.id}`)
                          }
                        />
                      </Button>
                      <Button variant="link" className="p-0 action-btn">
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="icon-delete"
                        />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15" className="text-center fw-bold">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="result_div">
        <p className="inner_text">
          Showing{" "}
          {Host?.data?.length > 0
            ? (Host.current_page - 1) * Host.per_page + 1
            : 0}{" "}
          to{" "}
          {(Host?.current_page - 1) * Host?.per_page +
            (Host?.data?.length || 0)}{" "}
          of {Host?.total || 0}
        </p>
      </div>
      {renderPagination(Host, handleCustomerPageChange)}
    </section>
  );
};

export default Student_Detail;
